import { render, staticRenderFns } from "./CheckboxGroup.vue?vue&type=template&id=5b137247&"
import script from "./CheckboxGroup.vue?vue&type=script&lang=js&"
export * from "./CheckboxGroup.vue?vue&type=script&lang=js&"
import style0 from "./CheckboxGroup.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports